import axiosInstance from "./axios";
import config from "./config";

export async function verifyUser() {
	try {
		const response = await axiosInstance.get(config.endpoints.user_verify);
		return response.data;
	} catch (error) {
		console.error("Error while verifying and fetching user :", error);
		throw error;
	}
};

export async function getUserConfig() {
    try {
		const response = await axiosInstance.get(config.endpoints.user_config);
		return response.data;
	} catch (error) {
		console.error("Error while fetching user config:", error);
        return null;
	}
}

export async function saveUserConfig(data) {
    try {
		const response = await axiosInstance.put(config.endpoints.user_config, data);
		return response.data;
	} catch (error) {
		console.error("Error while saving user config:", error);
        return null;
	}
}
